/**
 * HEAREN V1 - Audio Profile Constants
 * Centralized constants for audiometric profile display
 * 
 * This file is UI-only and does not affect audio processing logic.
 * Used to ensure consistent display across all player contexts.
 */

// Standard audiometric frequencies tested (in Hz)
export const AUDIO_BANDS = [125, 250, 500, 1000, 2000, 4000, 8000];

// Total number of frequencies for UI display
export const AUDIO_BANDS_COUNT = AUDIO_BANDS.length; // 7

/**
 * Get the display text for audio profile frequency count
 * @param {string} lang - 'fr' or 'en'
 * @returns {string} - e.g., "7 fréquences" or "7 frequencies"
 */
export const getFrequencyCountLabel = (lang = 'fr') => {
  const count = AUDIO_BANDS_COUNT;
  return lang === 'en' 
    ? `${count} frequencies` 
    : `${count} fréquences`;
};

/**
 * Get the short frequency count for inline display
 * @returns {string} - e.g., "(7 freq.)"
 */
export const getFrequencyCountShort = () => {
  return `(${AUDIO_BANDS_COUNT} freq.)`;
};

/**
 * Get active status text with frequency count
 * @param {string} lang - 'fr' or 'en'
 * @returns {string} - e.g., "Actif · 7 fréquences"
 */
export const getActiveProfileLabel = (lang = 'fr') => {
  const active = lang === 'en' ? 'Active' : 'Actif';
  return `${active} · ${getFrequencyCountLabel(lang)}`;
};
